import { render } from "./SingleCheckbox.vue?vue&type=template&id=657e5ab6"
import script from "./SingleCheckbox.vue?vue&type=script&lang=js"
export * from "./SingleCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__